module.exports = __webpack_public_path__ + "static/img/horror-hand-v7.cc89cf63.png";